import { lazy, FC, Suspense } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import TopBarProgress from 'react-topbar-progress-indicator';
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper';
import { MenuTestPage } from '../pages/MenuTestPage';
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils';
import type { WithChildren } from '../../_metronic/helpers';
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper';
import Dashboard from '../modules/dashboard/Dashboard';

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'));
  const NavPage = lazy(() => import('../modules/navbar/navbarPage'));
  const FooterPage = lazy(() => import('../modules/footer/footerPage'));
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'));
  const AboutPage = lazy(() => import('../modules/about/AboutPagee'));
  const BlogDetailPage = lazy(() => import('../modules/blogDetails/blogDetailsPage'));
  const FAQPage = lazy(() => import('../modules/faq/FaqPage'));
  const ContactPage = lazy(() => import('../modules/contact/contactPage'));
  const PrivacyPage = lazy(() => import('../modules/privacy/privacyPage'));
  const ResourcePage = lazy(() => import('../modules/resource/ResoucePage'));
  const BlogPage = lazy(() => import('../modules/blog/blogPage'));
  const CareerPage = lazy(() => import('../modules/career/careerPage'));
  const BusinessPage = lazy(() => import('../modules/business/businessPage'));
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'));
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'));
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'));
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'));
  const AdminUsersPage = lazy(() => import('../modules/apps/admin-users/AdminUsersPage'));

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/pages/home/intro' />} />

        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />

        {/* Lazy Modules */}
        <Route
          path='/pages/navbar/*'
          element={
            <SuspensedView>
              <NavPage />
              <Dashboard />
            </SuspensedView>
          }
        />
         <Route
          path='/pages/blog/*'
          element={
            <SuspensedView>
              <BlogPage />
              <Dashboard />
            </SuspensedView>
          }
        />
          <Route
          path='/pages/business/*'
          element={
            <SuspensedView>
              <BusinessPage />
              <Dashboard />
            </SuspensedView>
          }
        />
          <Route
          path='/pages/career/*'
          element={
            <SuspensedView>
              <CareerPage />
              <Dashboard />
            </SuspensedView>
          }
        />
         <Route
          path='/pages/privacy/*'
          element={
            <SuspensedView>
              <PrivacyPage />
              <Dashboard />
            </SuspensedView>
          }
        />
         <Route
          path='/pages/footer/*'
          element={
            <SuspensedView>
              <FooterPage />
              <Dashboard />
            </SuspensedView>
          }
        />
        <Route
          path='/pages/home/*'
          element={
            <SuspensedView>
              <ProfilePage />
              <Dashboard />
            </SuspensedView>
          }
        />
        <Route
          path='/pages/loan/*'
          element={
            <SuspensedView>
              <WizardsPage />
              <Dashboard />
            </SuspensedView>
          }
        />
        <Route
          path='/pages/about/*'
          element={
            <SuspensedView>
              <AboutPage />
              <Dashboard />
            </SuspensedView>
          }
        />
        <Route
          path='/pages/resource/*'
          element={
            <SuspensedView>
              <ResourcePage />
              <Dashboard />
            </SuspensedView>
          }
        />
         <Route
          path='/pages/blogDetail/*'
          element={
            <SuspensedView>
              <BlogDetailPage />
              <Dashboard />
            </SuspensedView>
          }
        />
         <Route
          path='/pages/faq/*'
          element={
            <SuspensedView>
              <FAQPage />
              <Dashboard />
            </SuspensedView>
          }
        />
         <Route
          path='/pages/contact/*'
          element={
            <SuspensedView>
              <ContactPage />
              <Dashboard />
            </SuspensedView>
          }
        />
        <Route
          path='/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/admin-users/*'
          element={
            <SuspensedView>
              <AdminUsersPage />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary');
  TopBarProgress.config({
    barColors: {
      0: baseColor
    },
    barThickness: 1,
    shadowBlur: 5
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
